<template>
  <div
    class="h-screen flex w-full bg-white vx-row no-gutter items-center justify-center relative"
  >
    <div class="absolute top-32 right-0 md:block lg:block hidden">
      <img
        src="./../../assets/images/bg-des/career-dots.svg"
        alt="Dots"
        class=""
      />
    </div>
    <div class="absolute bottom-32 left-0 md:block lg:block hidden">
      <img
        src="./../../assets/images/bg-des/CD-dots2.svg"
        alt="Dots"
        class=""
      />
    </div>
    <div class="absolute top-1/4 right-1/4 md:block lg:block hidden">
      <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
    </div>
    <div class="absolute top-1/2 left-20 md:block lg:block hidden">
      <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
    </div>

    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 absolute">
      <b-card no-body class="bg-secondary border-0 mb-0 p-0">
        <b-card-body class="lg:flex md:flex p-0 fullpage-bgcolor">
          <div
            class="lg:w-1/2 md:w-1/2 w-full lg:flex md:flex items-center justify-center"
          >
            <img src="@/assets/images/login.png" alt="login" class="mx-auto" />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full bg-white">
            <div class="p-4">
              <validation-observer ref="formValidator">
                <div v-show="!newpasswordpage">
                  <div class="mb-4">
                    <h4 class="mb-2 text-xl font-medium">
                      Active Your Account
                    </h4>
                    <p class="text-lg">
                      Please enter your email / mobile number.
                    </p>
                  </div>
                  <b-form class="cust-bform" role="form">
                    <base-input
                      alternative
                      class="mb-3"
                      name="Email / Mobile"
                      :rules="{ required: true }"
                      prepend-icon="ni ni-email-83"
                      placeholder="Email / Mobile"
                      v-model="userCred"
                      @keyup="handleUsername(userCred)"
                    >
                      <!-- @change="verifyUser(userCred)" -->
                    </base-input>

                    <OTP
                      @set-otp="setOTP"
                      :userCred="userCred"
                      :toActive="true"
                      type="ForgotPassword"
                    />

                    <div class="lg:flex md:flex gap-5 justify-between mt-4">
                      <base-button
                        type="primary"
                        outline
                        class="lg:w-full md:w-2/5 w-full mb-2"
                        @click="backtologin()"
                        >Back to Login</base-button
                      >
                      <base-button
                        type="primary"
                        :disabled="!(otp && userCred)"
                        class="lg:w-full md:w-2/5 w-full mb-2"
                        @click="verifyMobileNo()"
                        >Verify</base-button
                      >
                    </div>
                  </b-form>
                </div>
              </validation-observer>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import OTP from "./components/OTP.vue";
export default {
  data() {
    return {
      userCred: "",
      otp: "",
      rememberMe: false,
      Passwordreset: "",
      newpasswordpage: false,
      passwordFieldType1: "password",
      passwordFieldType2: "password",
      ruleForm: {
        password: "",
        Passwordconfirm: "",
      },
      rules: {
        password: [
          {
            required: true,
            message: "Please Enter Password",
            trigger: "change",
          },
          {
            trigger: "change",
            message:
              "Password must be at least 8 character long and include at least 1 digit,1 lowercase,1 uppercasse, 1 special character.",
            pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}$/,
          },
        ],
        Passwordconfirm: [
          {
            trigger: "change",
            validator: this.conPassValidator,
          },
        ],
      },
    };
  },
  metaInfo: {
    title: "Reset or change your password Caregiver Saathi",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Forgot Password? Follow the quick steps to reset your password. Login to Caregiver Saathi.",
      },
    ],
  },
  methods: {
    handleUsername(val) {
      if (this.userCred.includes("@" && "."))
        this.userCred = this.userCred.toLowerCase();
    },
    async verifyUser(val) {
      let payload;
      if (this.userCred.includes("CGX" && "EMP")) {
        payload = {
          eid: this.userCred,
        };
      } else if (this.userCred.includes("@" && ".")) {
        payload = {
          email: this.userCred.toLowerCase().trim(),
        };
      } else {
        payload = {
          mobile: this.userCred,
        };
      }
      try {
        const getUser = await this.$store.dispatch("auth/getUser", payload);
      } catch (error) {
        console.log(error);
        if (error.response.status) {
          this.$swal
            .fire({
              title: "Error",
              text: error.response.data.message,
              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            })
            .then((result) => {
              if (error.response.data.message == "Please set password!") {
                this.$router.push({
                  name: "forgot-password",
                  query: { setPassword: true },
                });
              }
              // if (
              //   error.response.data.message.includes(
              //     "Your account is in-active"
              //   )
              // ) {
              //   console.log("Move to activate account page");
              // }
            });
        }
      }
    },

    setOTP(otp) {
      this.otp = otp;
    },
    async verifyMobileNo() {
      const payload = {
        // mobile: this.mobile,
        otp: this.otp,
      };

      if (/^\d{10}$/g.test(this.userCred)) {
        Object.assign(payload, { mobile: this.userCred });
      }

      if (/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(this.userCred)) {
        Object.assign(payload, { email: this.userCred });
      }
      try {
        let data = await this.$store.dispatch("auth/VerifyOTP", payload);
        if (data.code == 200) {
          Object.assign(payload, { isActive: true });
          let active = await this.$store.dispatch(
            "eLearning/userActive",
            payload
          );
          if (active.code == 200) {
            this.$swal.fire({
              title: "Activated",
              html: `<p class="text-center">Your account has been activated successfully! Please login and continue</p>`,
              confirmButtonText: "Okay",
              icon: "success",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
            this.$router.push({ name: "home" });
          }
        }
      } catch (error) {
        if ("Error") {
          this.$swal.fire({
            title: "Error",
            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },
    async backtologin() {
      this.$router.push({ name: "signin" });
    },
  },
  components: {
    OTP,
  },
};
</script>

<style>
.login-tabs-container {
  min-height: 505px;
}
.cust-divider3 {
  border-bottom: 3px solid #e9ecef;
}
.fullpage-bgcolor {
  background-color: #eff2f7;
}
.bor {
  border: 1px solid rgba(155, 154, 154, 0.623);
}
.p-4 {
  padding: 1rem;
  background-color: #eff2f7;
}
</style>
